type Color = {
  primary: string;
  secondary: string;
};

export class Richtext {
  addPaddings: boolean;
  analyticsAttributes?: any;
  color: Color;
  text: any;
  useAsMessageComponent: boolean;
  fontSize?: string;

  constructor(props: any) {
    this.addPaddings = props.useWindowPadding;
    this.text = props.text;
    this.useAsMessageComponent = props.useAsMessageComponent;
    this.analyticsAttributes = props.analyticsAttributes;
    this.color = {
      primary: props.primaryFontColor || 'inherit',
      secondary: props.secondaryFontColor || props.primaryFontColor || 'inherit'
    };
    this.fontSize = props.fontSize || undefined;
  }
}

export default Richtext;
